/**
 * Brauzer Canvas API ilə şəkili sıxışdırır.
 * GIF-ləri dəyişdirmir (animated GIF dəstəyi yoxdur).
 * Nəticə: JPEG File, orijinaldən 5-10x kiçik.
 *
 * @param {File} file        - İstifadəçinin seçdiyi fayl
 * @param {object} options
 * @param {number} options.maxWidth  - Maksimum genişlik px (default: 1200)
 * @param {number} options.quality   - JPEG keyfiyyəti 0-1 (default: 0.82)
 * @returns {Promise<File>}  - Sıxışdırılmış JPEG fayl
 */
export function compressImage(file, { maxWidth = 1200, quality = 0.82 } = {}) {
  return new Promise((resolve) => {
    // GIF-ləri, video-ları dəyişdirmə
    if (!file.type.startsWith('image/') || file.type === 'image/gif') {
      resolve(file);
      return;
    }

    const url = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(url);

      let { width, height } = img;

      // Yalnız böyük şəkilləri kiçilt
      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width);
        width = maxWidth;
      }

      const canvas = document.createElement('canvas');
      canvas.width  = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) { resolve(file); return; }
          // Fayl adını .jpg et
          const name = file.name.replace(/\.[^.]+$/, '.jpg');
          resolve(new File([blob], name, { type: 'image/jpeg' }));
        },
        'image/jpeg',
        quality,
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(file); // xəta olarsa orijinalı göndər
    };

    img.src = url;
  });
}
